/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from '@codegrade/maybe';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeConfig(overrideConfig) {
    return Object.freeze({
        base: 'https://app.codegra.de',
        processError: Maybe.empty(),
        token: Maybe.empty(),
        headers: Maybe.empty(),
        fetch: (...args) => fetch(...args),
        ...overrideConfig,
    });
}
